import * as React from 'react';
export const IcZombie = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 4a1 1 0 00-1 1v2.33a.658.658 0 01-.66.67.67.67 0 01-.67-.67V4a1 1 0 10-2 0v3.33a.67.67 0 01-.925.619.66.66 0 01-.405-.619V3a1 1 0 10-2 0v4.33a.658.658 0 01-.66.67.67.67 0 01-.68-.67V4a1 1 0 10-2 0v4a1 1 0 01-2 0V7a1 1 0 00-2 0v3a4.94 4.94 0 001 3 5 5 0 004 2v1.17A3 3 0 0010 22a2.759 2.759 0 002-.79 3 3 0 103-5V15a5 5 0 004-2 4.94 4.94 0 001-3V5a1 1 0 00-1-1zm-5 16a1 1 0 01-.68-.26 2 2 0 00-2.64 0A1 1 0 0110 20a1 1 0 010-2 1 1 0 001-1v-2h2v2a1 1 0 001 1 1 1 0 110 2z'
      fill='currentColor'
    />
  </svg>
);
